module.exports = __webpack_public_path__ + "img/20230426170459.6b46936.png";